unit View.Cfop.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewCfopEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbcfop_cfop: TLabel;
    edcfop_cfop: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientCfopGet: TXDataWebClient;
    XDataClientCfopDelete: TXDataWebClient;
    CfopDataset: TXDataWebDataSet;
    CfopDatasetcfop_cfop: TStringField;
    CfopDatasetnome: TStringField;
    CfopDatasetexcluido: TBooleanField;
    CfopDatasetinclusao: TDateTimeField;
    CfopDatasetalteracao: TDateTimeField;
    CfopDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientCfopGetLoad(Response: TXDataClientResponse);
    procedure XDataClientCfopDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientCfopDeleteError(Error: TXDataClientError);
    procedure CfopDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewCfopEdit: TFViewCfopEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewCfopEdit }

procedure TFViewCfopEdit.btSaveClick(Sender: TObject);
begin
  if CfopDataset.State in dsEditModes then
  begin
        CfopDataset.Post;
    CfopDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewCfopEdit.btDeleteClick(Sender: TObject);
begin
  if CfopDataset.State in dsEditModes then
    CfopDataset.Post;
  XDataClientCfopDelete.Delete(CfopDataset.EntitySetName,
    TJSObject(CfopDataset.CurrentData));
end;


class function TFViewCfopEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewCfopEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewCfopEdit.InsertEntity;
begin
  CfopDataset.Close;
  CfopDataset.SetJsonData('{}');
  CfopDataset.Open;
  CfopDataset.Insert;
end;

class function TFViewCfopEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewCfopEdit(AForm).FInserting := AInserting;
    TFViewCfopEdit(AForm).FId := AId;
    TFViewCfopEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewCfopEdit(AForm).InsertEntity
    else
      TFViewCfopEdit(AForm).LoadEntity;
    TFViewCfopEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewCfopEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewCfopEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    CfopDataset.Connection.Model.DefaultSchema.FindEntityType(
      CfopDataset.EntitySetName
    )
  );
  XDataClientCfopGet.Get(CfopDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewCfopEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewCfopEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCfopEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewCfopEdit.XDataClientCfopGetLoad(Response: TXDataClientResponse);
begin
  CfopDataset.Close;
  CfopDataset.SetJsonData(Response.Result);
  CfopDataset.Open;
  
  CfopDataset.Edit;  
end;

procedure TFViewCfopEdit.XDataClientCfopDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewCfopEdit.XDataClientCfopDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewCfopEdit.CfopDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewCfopEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewCfopEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.cfop.form.message');
  lbMessage := TLabel.Create('view.cfop.form.message.label');
  btCloseMessage := TButton.Create('view.cfop.form.message.button');
  btCancel := TButton.Create('view.cfop.form.btBack');
  btSave := TButton.Create('view.cfop.form.btSave');
  btDelete := TButton.Create('view.cfop.form.btDelete');
  lbcfop_cfop := TLabel.Create('view.cfop.form.lbcfop_cfop');
  edcfop_cfop := TDBEdit.Create('view.cfop.form.edcfop_cfop');
  lbnome := TLabel.Create('view.cfop.form.lbnome');
  ednome := TDBEdit.Create('view.cfop.form.ednome');
  lbexcluido := TLabel.Create('view.cfop.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.cfop.form.edexcluido');
  lbinclusao := TLabel.Create('view.cfop.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.cfop.form.edinclusao');
  lbalteracao := TLabel.Create('view.cfop.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.cfop.form.edalteracao');
  lbexclusao := TLabel.Create('view.cfop.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.cfop.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  CfopDataset := TXDataWebDataSet.Create(Self);
  CfopDatasetcfop_cfop := TStringField.Create(Self);
  CfopDatasetnome := TStringField.Create(Self);
  CfopDatasetexcluido := TBooleanField.Create(Self);
  CfopDatasetinclusao := TDateTimeField.Create(Self);
  CfopDatasetalteracao := TDateTimeField.Create(Self);
  CfopDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientCfopGet := TXDataWebClient.Create(Self);
  XDataClientCfopDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbcfop_cfop.BeforeLoadDFMValues;
  edcfop_cfop.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  CfopDataset.BeforeLoadDFMValues;
  CfopDatasetcfop_cfop.BeforeLoadDFMValues;
  CfopDatasetnome.BeforeLoadDFMValues;
  CfopDatasetexcluido.BeforeLoadDFMValues;
  CfopDatasetinclusao.BeforeLoadDFMValues;
  CfopDatasetalteracao.BeforeLoadDFMValues;
  CfopDatasetexclusao.BeforeLoadDFMValues;
  XDataClientCfopGet.BeforeLoadDFMValues;
  XDataClientCfopDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewCfopEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 427;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 367;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 367;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 367;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbcfop_cfop.SetParentComponent(Self);
    lbcfop_cfop.Name := 'lbcfop_cfop';
    lbcfop_cfop.Left := 24;
    lbcfop_cfop.Top := 192;
    lbcfop_cfop.Width := 14;
    lbcfop_cfop.Height := 13;
    lbcfop_cfop.Caption := 'cfop_cfop:';
    lbcfop_cfop.Transparent := True;
    edcfop_cfop.SetParentComponent(Self);
    edcfop_cfop.Name := 'edcfop_cfop';
    edcfop_cfop.Left := 221;
    edcfop_cfop.Top := 189;
    edcfop_cfop.Width := 200;
    edcfop_cfop.Height := 21;
    edcfop_cfop.Enabled := True;
    edcfop_cfop.TabOrder := 6;
    edcfop_cfop.Text := 'edcfop_cfop';
    edcfop_cfop.DataField := 'cfop_cfop';
    edcfop_cfop.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 246;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 243;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 8;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 273;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 270;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 9;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 300;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 297;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 10;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 327;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 324;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 11;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := CfopDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    CfopDataset.SetParentComponent(Self);
    CfopDataset.Name := 'CfopDataset';
    CfopDataset.AfterApplyUpdates := CfopDatasetAfterApplyUpdates;
    CfopDataset.EntitySetName := 'Cfop';
    CfopDataset.Connection := DMConnection.ApiConnection;
    CfopDataset.Left := 176;
    CfopDataset.Top := 8;
    CfopDatasetcfop_cfop.SetParentComponent(CfopDataset);
    CfopDatasetcfop_cfop.Name := 'CfopDatasetcfop_cfop';
    CfopDatasetcfop_cfop.FieldName := 'cfop_cfop';
    CfopDatasetcfop_cfop.Required := True;
    CfopDatasetcfop_cfop.Size := 255;
    CfopDatasetnome.SetParentComponent(CfopDataset);
    CfopDatasetnome.Name := 'CfopDatasetnome';
    CfopDatasetnome.FieldName := 'nome';
    CfopDatasetnome.Required := True;
    CfopDatasetnome.Size := 255;
    CfopDatasetexcluido.SetParentComponent(CfopDataset);
    CfopDatasetexcluido.Name := 'CfopDatasetexcluido';
    CfopDatasetexcluido.FieldName := 'excluido';
    CfopDatasetexcluido.Required := False;
    CfopDatasetinclusao.SetParentComponent(CfopDataset);
    CfopDatasetinclusao.Name := 'CfopDatasetinclusao';
    CfopDatasetinclusao.FieldName := 'inclusao';
    CfopDatasetinclusao.Required := False;
    CfopDatasetalteracao.SetParentComponent(CfopDataset);
    CfopDatasetalteracao.Name := 'CfopDatasetalteracao';
    CfopDatasetalteracao.FieldName := 'alteracao';
    CfopDatasetalteracao.Required := False;
    CfopDatasetexclusao.SetParentComponent(CfopDataset);
    CfopDatasetexclusao.Name := 'CfopDatasetexclusao';
    CfopDatasetexclusao.FieldName := 'exclusao';
    CfopDatasetexclusao.Required := False;
    XDataClientCfopGet.SetParentComponent(Self);
    XDataClientCfopGet.Name := 'XDataClientCfopGet';
    XDataClientCfopGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCfopGet, Self, 'OnLoad', 'XDataClientCfopGetLoad');
    XDataClientCfopGet.Left := 64;
    XDataClientCfopGet.Top := 8;
    XDataClientCfopDelete.SetParentComponent(Self);
    XDataClientCfopDelete.Name := 'XDataClientCfopDelete';
    XDataClientCfopDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientCfopDelete, Self, 'OnLoad', 'XDataClientCfopDeleteLoad');
    SetEvent(XDataClientCfopDelete, Self, 'OnError', 'XDataClientCfopDeleteError');
    XDataClientCfopDelete.Left := 64;
    XDataClientCfopDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbcfop_cfop.AfterLoadDFMValues;
    edcfop_cfop.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    CfopDataset.AfterLoadDFMValues;
    CfopDatasetcfop_cfop.AfterLoadDFMValues;
    CfopDatasetnome.AfterLoadDFMValues;
    CfopDatasetexcluido.AfterLoadDFMValues;
    CfopDatasetinclusao.AfterLoadDFMValues;
    CfopDatasetalteracao.AfterLoadDFMValues;
    CfopDatasetexclusao.AfterLoadDFMValues;
    XDataClientCfopGet.AfterLoadDFMValues;
    XDataClientCfopDelete.AfterLoadDFMValues;
  end;
end;

end.
